import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';
interface RevealProps {
  children: ReactNode;
  delay?: number;
  className?: string;
}
export function Reveal({
  children,
  delay = 0,
  className
}: RevealProps) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y: 30,
    filter: 'blur(8px)'
  }} whileInView={{
    opacity: 1,
    y: 0,
    filter: 'blur(0px)'
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 1,
    delay,
    ease: [0.16, 1, 0.3, 1]
  }} data-id="element-187" data-mp="3bi5wa5v5c6hm">
      {children}
    </motion.div>;
}